import { normalizeBrandSubdomain } from '@zealot/shared';
import { isPreviewHost } from '@/lib/utils/navigation';

// gloss
type BuildLogoutOptionsArgs = {
  brand?: string | null;
  origin: string;
  portalBaseUrl?: string;
};

type LogoutOptions = {
  logoutParams: {
    returnTo: string;
    federated: true;
  };
};

const getHostname = (origin: string): string | null => {
  try {
    return new URL(origin).hostname;
  } catch {
    return null;
  }
};

// gloss
export const buildLogoutOptions = ({ brand, origin, portalBaseUrl }: BuildLogoutOptionsArgs): LogoutOptions => {
  const onPreviewHost = isPreviewHost(getHostname(origin));
  const hasBrandToken = portalBaseUrl?.includes('{brand}');

  let returnTo: string;
  if (onPreviewHost) {
    returnTo = brand ? `${origin}?brand=${encodeURIComponent(brand)}` : origin;
  } else if (hasBrandToken && portalBaseUrl) {
    const subdomain = normalizeBrandSubdomain(brand);
    returnTo = subdomain ? portalBaseUrl.replace('{brand}', subdomain) : origin;
  } else if (portalBaseUrl && brand) {
    returnTo = `${portalBaseUrl}?brand=${encodeURIComponent(brand)}`;
  } else {
    returnTo = portalBaseUrl || origin;
  }

  return {
    logoutParams: {
      returnTo,
      // why: federated:true must always be set on logout — without it Auth0 silently re-auths
      // why: and onboarding can misfire for a real user.
      federated: true,
    },
  };
};
